var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-media-link",attrs:{"data-mode":_vm.mode}},[_c('LinkManual',{attrs:{"type":"external","url":_vm.link.link.cached_url}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }